// Gorselleri KLASORE indir. Chrome/Edge: kullanici klasor secer, gorseller
// (istenirse) urun adli bir alt klasore sirali adlarla yazilir. Desteklemeyen
// tarayicida tek tek indirme yapilir.

type DirHandle = {
  getDirectoryHandle: (name: string, o?: { create?: boolean }) => Promise<DirHandle>;
  getFileHandle: (name: string, o?: { create?: boolean }) => Promise<{ createWritable: () => Promise<{ write: (b: Blob) => Promise<void>; close: () => Promise<void> }> }>;
};

export function slugify(s: string): string {
  return s
    .toLowerCase()
    .replace(/[ğ]/g, "g").replace(/[ü]/g, "u").replace(/[ş]/g, "s").replace(/[ı]/g, "i").replace(/[ö]/g, "o").replace(/[ç]/g, "c")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || "gorsel";
}

const extOf = (type: string) => (type.includes("png") ? "png" : type.includes("webp") ? "webp" : "jpg");

export function folderPickerSupported(): boolean {
  return typeof (window as unknown as { showDirectoryPicker?: unknown }).showDirectoryPicker === "function";
}

/** Donus: kaydedilen dosya sayisi ve kullanilan yol. Kullanici iptal ederse null. */
export async function downloadImagesToFolder(
  urls: string[],
  opts: { baseName: string; subfolder?: string; onProgress?: (done: number, total: number) => void },
): Promise<{ saved: number; mode: "folder" | "files" } | null> {
  const base = slugify(opts.baseName);
  const pad = (i: number) => String(i + 1).padStart(2, "0");
  const picker = (window as unknown as { showDirectoryPicker?: (o?: unknown) => Promise<DirHandle> }).showDirectoryPicker;

  if (picker) {
    let root: DirHandle;
    try { root = await picker({ mode: "readwrite" }); } catch { return null; } // iptal
    const dir = opts.subfolder ? await root.getDirectoryHandle(slugify(opts.subfolder), { create: true }) : root;
    let saved = 0;
    for (let i = 0; i < urls.length; i++) {
      try {
        const blob = await (await fetch(urls[i])).blob();
        const fh = await dir.getFileHandle(`${base}-${pad(i)}.${extOf(blob.type)}`, { create: true });
        const w = await fh.createWritable();
        await w.write(blob);
        await w.close();
        saved++;
      } catch { /* tek dosya hatasi digerlerini durdurmasin */ }
      opts.onProgress?.(i + 1, urls.length);
    }
    return { saved, mode: "folder" };
  }

  // Yedek: tek tek indir (tarayici "coklu indirme" izni isteyebilir)
  let saved = 0;
  for (let i = 0; i < urls.length; i++) {
    try {
      const blob = await (await fetch(urls[i])).blob();
      const a = document.createElement("a");
      const u = URL.createObjectURL(blob);
      a.href = u; a.download = `${base}-${pad(i)}.${extOf(blob.type)}`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(u), 2000);
      saved++;
      await new Promise((r) => setTimeout(r, 300));
    } catch { /* atla */ }
    opts.onProgress?.(i + 1, urls.length);
  }
  return { saved, mode: "files" };
}
